import React from "react";
import {
  Box,
  Button,
  IconButton,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  MenuItem,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DeleteIcon from "@mui/icons-material/Delete";
import SendIcon from "@mui/icons-material/Send";
import { CURRENCIES, type WireTransferAccordionProps } from "./types";

export const WireTransferAccordion: React.FC<WireTransferAccordionProps> = ({
  expanded,
  onAccordionChange,
  wireRows,
  clients,
  custodians,
  handleWireChange,
  handleAddWireRow,
  handleRemoveWireRow,
  handleReAddWireRow,
}) => {
  return (
    <Accordion
      expanded={expanded}
      onChange={onAccordionChange}
      sx={{ mb: 2 }}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          <SendIcon color="primary" />
          <Typography fontWeight={500}>Add Wire Transfer</Typography>
          <Typography variant="body2" color="text.secondary">
            (Cash Management)
          </Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Client</TableCell>
                <TableCell>Amount</TableCell>
                <TableCell>Currency</TableCell>
                <TableCell>From Custodian</TableCell>
                <TableCell>To Custodian</TableCell>
                <TableCell width={100}></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {wireRows.map((row, index) => (
                <TableRow key={row.id}>
                  <TableCell>
                    <TextField
                      select
                      size="small"
                      value={row.client_id}
                      onChange={(e) => handleWireChange(row.id, "client_id", e.target.value)}
                      variant="standard"
                      sx={{ minWidth: 150 }}
                    >
                      <MenuItem value="">Select...</MenuItem>
                      {clients.map((c) => (
                        <MenuItem key={c.client_id} value={c.client_id}>
                          {c.client_name}
                        </MenuItem>
                      ))}
                    </TextField>
                  </TableCell>
                  <TableCell>
                    <TextField
                      type="number"
                      size="small"
                      value={row.amount || ""}
                      onChange={(e) => handleWireChange(row.id, "amount", parseFloat(e.target.value) || 0)}
                      variant="standard"
                      sx={{ width: 120 }}
                    />
                  </TableCell>
                  <TableCell>
                    <TextField
                      select
                      size="small"
                      value={row.currency}
                      onChange={(e) => handleWireChange(row.id, "currency", e.target.value)}
                      variant="standard"
                      sx={{ width: 100 }}
                    >
                      {CURRENCIES.map((c) => (
                        <MenuItem key={c} value={c}>{c}</MenuItem>
                      ))}
                    </TextField>
                  </TableCell>
                  <TableCell>
                    <TextField
                      select
                      size="small"
                      value={row.from_custodian_id}
                      onChange={(e) => handleWireChange(row.id, "from_custodian_id", e.target.value)}
                      variant="standard"
                      sx={{ minWidth: 120 }}
                    >
                      <MenuItem value="">Select...</MenuItem>
                      {custodians.map((c) => (
                        <MenuItem key={c.custodian_id} value={c.custodian_id}>
                          {c.custodian_name}
                        </MenuItem>
                      ))}
                    </TextField>
                  </TableCell>
                  <TableCell>
                    <TextField
                      select
                      size="small"
                      value={row.to_custodian_id}
                      onChange={(e) => handleWireChange(row.id, "to_custodian_id", e.target.value)}
                      variant="standard"
                      sx={{ minWidth: 120 }}
                    >
                      <MenuItem value="">Select...</MenuItem>
                      {custodians.map((c) => (
                        <MenuItem key={c.custodian_id} value={c.custodian_id}>
                          {c.custodian_name}
                        </MenuItem>
                      ))}
                    </TextField>
                  </TableCell>
                  <TableCell>
                    <Box sx={{ display: "flex", gap: 0.5, alignItems: "center" }}>
                      {index === wireRows.length - 1 ? (
                        <Button
                          size="small"
                          variant="outlined"
                          onClick={handleAddWireRow}
                          sx={{ minWidth: 60 }}
                        >
                          ADD
                        </Button>
                      ) : (
                        <>
                          <Button
                            size="small"
                            variant="outlined"
                            onClick={() => handleReAddWireRow(row)}
                            sx={{ minWidth: 60 }}
                          >
                            ADD
                          </Button>
                          <IconButton
                            size="small"
                            onClick={() => handleRemoveWireRow(row.id)}
                          >
                            <DeleteIcon fontSize="small" />
                          </IconButton>
                        </>
                      )}
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </AccordionDetails>
    </Accordion>
  );
};
